import React from 'react';
import { select } from 'd3';
import { Grid, Switch, Typography } from '@material-ui/core';
import '../css/Graph.css';
import Line from '../../lib/LineChart';

export default class LineGraph extends React.Component {
  componentDidMount() {
    const margins = {top: 30, bottom: 40, left: 60, right: 200};
    this.graph = new Line(this.svg, 500, 1200, margins, 
      this.props.transitionTime, this.tooltipDiv);

    this.updateGraph();
  }

  componentDidUpdate() {
    this.updateGraph()
  }

  shouldComponentUpdate(nextProps) {
    const [nextMin, nextMax] = nextProps.yearRange,
          [min, max] = this.props.yearRange;
    
    if (nextMin !== min || nextMax !== max) {
      this.graph.setYearRange([nextMin, nextMax]);
      return false;
    } else {
      return true;
    }
  }

  updateGraph() {
    this.graph.setData(this.props.data);
    this.graph.setUnits(this.props.units);
    this.graph.setTransitionTime(this.props.transitionTime);
    this.graph.drawChart();
    this.graph.setYearRange(this.props.yearRange);
  }

  handleScaleChange = (e, isLinear) => {
    if (isLinear) this.graph.toLinearScale();
    else this.graph.toLogScale();
  }

  render() {
    return (
      <div className="lineGraphContainer">
        <svg 
          ref={(svg) => this.svg = select(svg)}>
        </svg>
        <div 
          className='tooltip'
          ref={(div) => this.tooltipDiv = select(div)}>
        </div>
        <Grid 
          justify="flex-end" 
          component="label" 
          container 
          alignItems="center" 
          spacing={2}
        >
          <Grid item>
            <Typography variant="subtitle2">LOG</Typography>
          </Grid>
          <Grid item>
            <Switch
              defaultChecked
              onChange={this.handleScaleChange}
              value="checkedF"
              color="default"
            />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2">LINEAR</Typography>
          </Grid>
        </Grid>
      </div>
    );      
  }
}
